import React from 'react'

const documentColumns = () => {
  return [
    {
      dataIndex: 'fileUri',
      key: 'fileUri',
      render: (text, record, index) => null
    },
    {
      title: '文件名称',
      dataIndex: 'fileName',
      key: 'fileName',
    },
    {
      title: '附件格式',
      dataIndex: 'attachmentFormat',
      key: 'attachmentFormat',
    },
    {
      title: '文件大小',
      dataIndex: 'fileSize',
      key: 'fileSize',
    },
    {
      title: '上传时间',
      dataIndex: 'uploadTime',
      key: 'uploadTime',
    },
    {
      title: '操作',
      dataIndex: 'options',
      key: 'options',
      width: 100,
      render: (text, record, index) => {
        const _click = () => {
          const x = new XMLHttpRequest();
          x.open('GET', record.fileUri, true);
          x.responseType = 'blob';
          x.onload = function () {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.download = record.originalFileName || '';
            a.click();
          };
          x.send();
        }

        return <a onClick={_click} style={{ color: '#1890ff' }}>下载</a>
      }
    }
  ]
}

const downLoadColumns = handleDownLoad => [
  {
    dataIndex: 'fileuri',
    key: 'fileuri',
    render: (text, record, index) => null
  },
  {
    title: '文件名称',
    dataIndex: 'filename',
    key: 'filename',
  },
  {
    title: '附件格式',
    dataIndex: 'attachmentFormat',
    key: 'attachmentFormat',
  },
  {
    title: '文件大小',
    dataIndex: 'filesize',
    key: 'filesize',
  },
  {
    title: '上传时间',
    dataIndex: 'uploadTime',
    key: 'uploadTime',
  },
  {
    title: '操作',
    dataIndex: 'options',
    key: 'options',
    width: 100,
    render: (text, record, index) => <a
    // onClick={handleDownLoad}
      href={record.fileuri} style={{ color: '#1890ff' }}>下载</a>

  }
]

export {documentColumns, downLoadColumns}
export default downLoadColumns
